export const wallet = {
  wallet_deposits: "Deposito's",
};

export default wallet;
